import { Alert, FormControl, InputLabel, MenuItem, Select, Stack, Typography } from '@mui/material'
import {
  EquipmentOperatorLandingFormData,
  EquipmentOperatorLandingUIStore,
} from '@operations/features/equipmentOperator/stores/equipment-operator-landing.ui-store'
import { EquipmentStatusChip } from '@operations/features/equipments/components/statusChip/EquipmentStatus'
import { useTranslate } from '@tolgee/react'
import { useMinimalsTheme } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { Controller, useFormContext } from 'react-hook-form'

interface Props {
  uiStore: EquipmentOperatorLandingUIStore
}

export const SelectEquipment = observer(({ uiStore }: Props) => {
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const { control } = useFormContext<EquipmentOperatorLandingFormData>()

  return (
    <Controller
      control={control}
      name={'equipmentId'}
      rules={{ required: true }}
      render={({ field: { onChange, value } }) => (
        <FormControl fullWidth>
          <InputLabel required>{t('equipmentName', 'Equipment name')}</InputLabel>
          <Select
            label={t('equipmentName', 'Equipment name')}
            defaultValue=''
            value={value?.toString() ?? ''}
            onChange={(e: any) => {
              onChange(e.target.value)
            }}
            renderValue={selected =>
              uiStore.equipmentOptions.find(x => x.id.toString() === selected)?.name
            }
            data-cy='operator-select-equipment-field'
          >
            {uiStore.equipmentOptions.map(option => (
              <MenuItem
                key={option.id}
                value={option.id}
                data-cy='operator-select-equipment-option'
              >
                <Stack gap={theme => theme.customSpacing.xs}>
                  <Stack direction='row'>
                    <Typography variant='subtitle1'>{option.name}</Typography>
                    {option.lastOperatorUserName && (
                      <Typography sx={{ marginLeft: theme.customSpacing.xxs }} variant='body1'>
                        {option.lastOperatorUserName}
                      </Typography>
                    )}
                  </Stack>
                  <EquipmentStatusChip
                    operationalStatus={option.operationalStatus}
                    isOwned={option.isOwned}
                    isInactive={!option.isActive}
                    isInOperation={false}
                  />
                </Stack>
              </MenuItem>
            ))}
          </Select>
          {uiStore.warningForUserName && (
            <Alert severity='warning' sx={{ margin: theme.customSpacing.m }}>
              {t(
                'equipmentAlreadyOccupied',
                '{userName} is currently logged into this equipment. Signing in will log them out.',
                { userName: uiStore.warningForUserName },
              )}
            </Alert>
          )}
        </FormControl>
      )}
    />
  )
})
